<template>
<div>
  <v-autocomplete outlined hide-details
    :loading="isLoadingSites"
    :items="userDomains"
    item-text="url"
    item-value="url"
    v-model="selectedDomain"
    color="green7Color"
  >
    <template v-slot:item="data">
      <v-list-item :disabled="!data.item.valid" @click="() => {
        if (data.item.valid) {
          selectedDomain = data.item.url;
        }
      }">
        {{ data.item.url }}
      </v-list-item>
    </template>
  </v-autocomplete>
</div>
</template>

<script>

import { EventEmitter } from '@/utils/Event.js';
import { loadGAPIClient, getSitesList, restoreBackendGoogleSession } from '@/utils/search-console-helper.js';
import { isRootDomainSame } from '@/utils';

export default {
  props: {
    baseDomain: {
      default: '',
    },
    initialDomain: {
      default: '',
    }
  },
  data () {
    return {
      googleUserEmail: null,
      isLoadingSites: false,

      selectedDomain: '',

      sites: [],

    }
  },
  computed: {
    googleUser () {
      return this.$store.state.googleUser;
    },
    userDomains () {
      let results = []
      if (this.sites) {
        this.sites.forEach((site) => {
          try {
              const site$ = site.replace('sc-domain:', '')
              const isValid = isRootDomainSame(site$, this.baseDomain)
              results.push({
                  url: site,
                  valid: isValid
              })
          } catch (e) {
              results.push({
                  url: site,
                  valid: false
              })
          }
        })
      }
      return results
    }
  },
  watch: {
    googleUserEmail: function (newVal, oldVal) {
      if (newVal) {
        this.loadDomainsFromGoogle();
      }
    },
    selectedDomain: function (newVal, oldVal) {
      this.$emit('onChangeDomain', newVal);
    }
  },
  methods: {
    initGoogleAuth() {
      // Restore the backend-held Google session (refresh token stored via the
      // Wins/Settings or connect-button flows); injects the access token into
      // gapi.client so getSitesList() below works without a popup.
      restoreBackendGoogleSession(this.$store).then((user) => {
        if (user) {
          this.googleUserEmail = user.email;
        }
      });
    },
    loadDomainsFromGoogle () {
      this.isLoadingSites = true;
      loadGAPIClient().then(() => {
        setTimeout(async () => {
          try {
            const res = await getSitesList();
            if (res && res.status == 200) {
              this.sites = (res.result.siteEntry || []).map(s => s.siteUrl);

              // auto select initialDomain if given
              if (this.initialDomain && !this.selectedDomain) {
                const correspondingItem = this.userDomains.filter(
                  item => item.valid && item.url.replace('sc-domain:', '') === this.initialDomain
                )[0];
                if (correspondingItem) {
                  this.selectedDomain = correspondingItem.url
                }
              }
            }
            this.isLoadingSites = false;
          } catch (error) {
            this.isLoadingSites = false;
            console.error(error)
            throw error
          }
        }, 3000);
      }).catch((e) => {
        console.info('=== loadGAPIClient Error ===', JSON.stringify(e, null, 4))
        this.isLoadingSites = false;
      })
    }
  },
  mounted () {
    this.initGoogleAuth();
    EventEmitter.subscribe('GOOGLE_USER_UPDATE', (gu) => {
      this.googleUserEmail = gu?.email;
    })
  }

}
</script>

<style lang="scss" scoped>

</style>